var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "personalizacao-canvas" },
    [
      _c(
        "draggable",
        {
          staticClass: "personalizacao-canvas__lista",
          attrs: {
            group: { name: "painel-insights", pull: true, put: true },
            animation: 200,
            "ghost-class": "personalizacao-canvas__ghost",
            "data-test": "personalizacao-canvas-area"
          },
          on: { change: _vm.onChange },
          model: {
            value: _vm.itensLocais,
            callback: function($$v) {
              _vm.itensLocais = $$v
            },
            expression: "itensLocais"
          }
        },
        _vm._l(_vm.entradas, function(entrada) {
          return _c(
            "div",
            {
              key: entrada.item.id,
              staticClass: "personalizacao-canvas__item",
              class: {
                "personalizacao-canvas__item--compacto": entrada.compacto
              },
              style: entrada.estilo,
              attrs: { "data-test": "personalizacao-canvas-item" }
            },
            [
              _c(
                "div",
                { staticClass: "personalizacao-canvas__toolbar" },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "mdi-drag-vertical",
                      color: "var(--muted)",
                      size: "14",
                      "aria-label": _vm.texto.personalizacaoArrastar,
                      title: _vm.texto.personalizacaoArrastar
                    }
                  }),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        icon: "",
                        "x-small": "",
                        "aria-label": _vm.texto.personalizacaoOcultar,
                        title: _vm.texto.personalizacaoOcultar
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.remover(entrada.item.id)
                        }
                      }
                    },
                    [
                      _c("icon-svg", {
                        attrs: { name: "eye-close", size: 14, color: "muted" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "IaInsightCard",
                _vm._b({}, "IaInsightCard", entrada.props, false)
              )
            ],
            1
          )
        }),
        0
      ),
      !_vm.itensLocais.length
        ? _c(
            "div",
            {
              staticClass: "personalizacao-canvas__vazio ia-sidebar-aux",
              attrs: { "data-test": "personalizacao-canvas-vazio" }
            },
            [_vm._v(" " + _vm._s(_vm.texto.personalizacaoCanvasVazio) + " ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }